/** Locale-aware date/time formatting for scheduling + session log (Italian UI). */

const LOCALE = 'it-IT';

export function formatDateTime(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(LOCALE, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDate(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' });
}

/** A proposed slot rendered with its optional duration, e.g. "mar 12 giu · 20:30 (3h)". */
export function formatSlot(start: string, durationMin?: number): string {
  const base = formatDateTime(start);
  if (!durationMin) return base;
  const h = Math.floor(durationMin / 60);
  const m = durationMin % 60;
  const dur = h ? `${h}h${m ? ` ${m}m` : ''}` : `${m}m`;
  return `${base} (${dur})`;
}

/** Value for an <input type="datetime-local"> from an ISO string. */
export function toDatetimeLocal(iso?: string): string {
  const d = iso ? new Date(iso) : new Date();
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** ISO string from an <input type="datetime-local"> value. */
export function fromDatetimeLocal(value: string): string {
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString();
}
